import React from "react"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import {
  nePasManquerItem,
  nePasManquerItemDescription,
  nePasManquerItemContainer,
} from "../ne-pas-manquer.module.scss"
import { Link } from "./ne-pas-manquer-item-styled"
import PropTypes from "prop-types"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const NePasManquerItem = ({ nePasManquer }) => (
  <li className={nePasManquerItemContainer}>
    <EditButton link={"/node/" + nePasManquer.drupal_internal__nid + "/edit"} />
    <TransitionFade link={nePasManquer.path.alias}>
      <div className={nePasManquerItem}>
        <NonStretchedImage
          {...nePasManquer?.relationships?.field_image_page_de_base?.localFile}
          ariaHidden={true}
        />
        <h3 className={nePasManquerItemDescription}>{nePasManquer.title}</h3>
        <Link>
          Voir
          <span aria-hidden={true}> &rarr;</span>
        </Link>
      </div>
    </TransitionFade>
  </li>
)

NePasManquerItem.propTypes = {
  nePasManquer: PropTypes.object.isRequired,
}

export default NePasManquerItem
